/**
 * Context for managing how the Freecode page is displayed.
 */
import React, { useState, useEffect } from 'react';

import { useWindowSize } from 'hooks/useWindowSize';
import { layouts, displayLayouts } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';

export const FreecodeContextLayout = React.createContext();

export const FreecodeContextLayoutProvider = ({ children }) => {
  const [displaySubmit, setDisplaySubmit] = useState(false);
  const [editorType, setEditorType] = useState(undefined);
  const [layout, setLayout] = useState(layouts.spinner);
  const [layoutForced, setLayoutForced] = useState(localStorage.getItem('fsEditor-layoutForced'));

  const size = useWindowSize();

  useEffect(() => {
    if (layoutForced && displayLayouts.includes(layoutForced)) {
      if (layoutForced !== layout) setLayout(layoutForced);
      return;
    }

    let tmpLayout = layouts.default;
    if (size?.width && size.width >= 1900 && size.width / size.height > 1.5) {
      tmpLayout = layouts.wide;
    } else if ((size?.width && size.width < 900) || size.height / size.width > 2) {
      tmpLayout = layouts.small;
    }
    if (tmpLayout !== layout) {
      setLayout(tmpLayout);
    }
  }, [size, layout, layoutForced]);

  return (
    <FreecodeContextLayout.Provider
      value={{
        displaySubmit,
        setDisplaySubmit,
        editorType,
        setEditorType,
        layout,
        setLayout,
        layoutForced,
        setLayoutForced,
      }}
    >
      {children}
    </FreecodeContextLayout.Provider>
  );
};
